// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const resetSearchFilters = state =>
    SearchFilters.update(state, {
        $set: getWipDefaultState().specialAllowanceClaimsSearchFilters
    });

const updateSearchFilters = (state, action) =>
    SearchFilters.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

export default (state = getWipDefaultState().specialAllowanceClaimsSearchFilters, action) => {

    const actionTypes = {
        [actions.RESET_TABM_SPA_CLAIMS_SEARCH_FILTERS]: resetSearchFilters,
        [actions.UPDATE_TABM_SPA_CLAIMS_FILTER_BY]: updateSearchFilters,
        [actions.UPDATE_TABM_SPA_CLAIMS_SORT_BY]: updateSearchFilters,
        [actions.UPDATE_TABM_SPA_CLAIMS_SORT_DIRECTION]: updateSearchFilters
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/wip/reducers/spa-claims-search-filters.js